// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-list-content[data-v-52240926] {\n  padding: 8px 35px;\n  overflow:auto;\n  height:100%;\n}\n", ""]);
// Exports
module.exports = exports;
